export * from './teacherLinks'
export * from './teacherRoutes'